// Definition of Regex Constants

export default {
  isMobile: /^0\d{10}$/,
  isEmail: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  isMobileOrEmail: /^(0\d{10}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
  isNumber: /^[\u06F0-\u06F9\u0660-\u06690-9]*$/,
  notNumber: /^([^\u06F0-\u06F9\u0660-\u06690-9]*)$/,
  isNationalCode: /^[\u06F0-\u06F9\u0660-\u06690-9]{10}$/,
  isTel: /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/,
  isPersian: /^[\u0621-\u063A\u0641-\u064A\u0676-\u06D1\s\u06F0-\u06F9\u0660-\u06690-9./]*$/,
  notEnglish: /^[^/._@#$%*+=A-Za-z0-9]*$/,
  isDecimal: /^\d+\.\d{0,20}$/,
  isRole: /^[_A-Z]*$/,
  isPermission: /^[_A-Z]*$/,
  isHost: /^(localhost|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d{1,5})?$/,
  isAlias: /^[-_a-z0-9]*$/,
  setAlias: /([^-_a-z0-9])+/g,
};
